//import Vue from 'vue'
import moment from 'moment'
import COMMON from '@/plugins/handsontable_common'

const _DATA = () => {
    // MARUNAGE_TABLE
    const DATA = {}
    DATA.CONSTS = {
        SEQUENCE_NUMBER_DIGITS: 3,
    }
    DATA.METHODS = {
        data2JsonObject: (data) => {
            return data
                .map((v) => {
                    let data = {}
                    for (let i = 0; i < DATA.FIELDS_ALL.length; i++) {
                        data[DATA.FIELDS_ALL[i].name] = DATA.FIELDS_ALL[i].get(v[i], v)
                    }
                    return data
                })
        },
        Couriers_domestic: () => {
            return {
                'dhl': 'DHL',
                'fedex': 'FedEx',
                'ups': 'UPS',
                'japanpost': 'EMS/飛脚GP便',
                'ecms': 'ECMS',
                'orangeconnex': 'OrangeConnex',
            }
        },
        Couriers_international: () => {
            return {
                'dhl': 'DHL',
                'fedex': 'FedEx',
                'ups': 'UPS',
                'japanpost': 'EMS/飛脚GP便',
                'ecms': 'ECMS',
                'orangeconnex': 'OrangeConnex',
            }
        },
    }
    // MARUNAGE_TABLE
    DATA.RENDERERS = {
        shipping_courier: (instance, td, row, col, prop, value, cellProperties) => {
            const obj = DATA.METHODS.data2JsonObject([ instance.getDataAtRow(row) ])[0]
        
            td.innerText = ''
            if (!value) {
                return td
            }
        
            const span = document.createElement('span')
            span.innerText = DATA.METHODS.Couriers_international()[value]
            td.appendChild(span)
            return td
        },
        shipping_tracking_codes: (instance, td, row, col, prop, value, cellProperties) => {
            const obj = DATA.METHODS.data2JsonObject([ instance.getDataAtRow(row) ])[0]
        
            td.innerText = ''
            if (!value) {
                return td
            }
        
            const a = document.createElement('a')
            a.href = 'https://t.17track.net/ja#nums=' + value.split("\n").join(',')
            switch (obj.shipping_courier) {
                case 'fedex':
                    a.href += '&fc=100003'
                    break
                case 'ups':
                    a.href += '&fc=100002'
                    break
                case 'dhl':
                    a.href += '&fc=100001'
                    break
                case 'japanpost':
                    a.href += '&fc=10021'
                    break
                case 'ecms':
                    a.href += '&fc=190168'
                    break
                case 'orangeconnex':
                    a.href += '&fc=190205'
                    break
            }
            a.target = '_blank'
            a.innerText = value
            td.appendChild(a)
            return td
        },
        shipping_item_currency: (instance, td, row, col, prop, value, cellProperties) => {
            const obj = DATA.METHODS.data2JsonObject([ instance.getDataAtRow(row) ])[0]
        
            td.innerText = ''
            if (!value) {
                return td
            }
        
            const span = document.createElement('span')
            span.innerText = value
//            span.innerText = DATA.METHODS.sourceCurrencies()[value]
            td.appendChild(span)
            return td
        },
        PEC: (instance, td, row, col, prop, value, cellProperties) => {
            td.innerText = ''
            if (!value) {
                return td
            }
            if (!value.marunage_user_id || !moment(value.issued_at).format('YYMMDD') || !value.sequence_number) {
                return td
            }
            td.className = cellProperties.className
        
            const span = document.createElement('span')
            span.innerText = value.marunage_user_id
                + moment(value.issued_at).format('YYMMDD')
                + String(value.sequence_number).padStart(DATA.CONSTS.SEQUENCE_NUMBER_DIGITS, '0')
            td.appendChild(span)
            return td
        },
        SEQUENCE_NUMBER: (instance, td, row, col, prop, value, cellProperties) => {
            td.innerText = ''
            if (!value) {
                return td
            }
            td.className = cellProperties.className
        
            const span = document.createElement('span')
            span.innerText = value
            td.appendChild(span)
            return td
        },
        MEDIA: (instance, td, row, col, prop, value, cellProperties) => {
            td.innerText = ''
            if (!Array.isArray(value)) {
                return td
            }
            td.className = cellProperties.className
        
            for (let i = 0; i < value.length; i++) {
                const img = document.createElement('IMG');
                img.src = value[i];
//            Handsontable.dom.addEvent(img, 'mousedown', event => {
//                event.preventDefault();
//            });
//            Handsontable.dom.empty(td);
                td.appendChild(img)
            }
            return td
        },
        STATUS: (instance, td, row, col, prop, value, cellProperties) => {
            td.innerText = ''
            if (!value) {
                return td
            }
            td.className = cellProperties.className
        
            const span = document.createElement('span')
            span.innerText = document.querySelector('.marunage-table').__vue__.trans.labels['marunage.status.' + value]
            td.appendChild(span)
            return td
        },
        ELLIPSIS: (instance, td, row, col, prop, value, cellProperties) => {
            td.innerText = ''
            if (!value) {
                return td
            }
            td.className = cellProperties.className
        
            const span = document.createElement('span')
            value = String(value)
//            if (value.length > 20) {
//                span.innerText = value.substring(0, 20) + '…'
//            } else {
                span.innerText = value
//            }
td.style.textOverflow = 'ellipsis';
td.style.whiteSpace = 'nowrap';
td.style.overflow = 'hidden';
//td.style.maxWidth = '0';
td.style.maxWidth = '20em';
td.style.width = '20em';
            td.appendChild(span)
            return td
        },
    }
    // MARUNAGE_TABLE
    DATA.FIELDS = {
        // システム入力
        SYSTEM: [
            {
                name: 'user_id',
                get: (v, v_all) => { return v },
                load: (v) => { return v.user_id },
                colHeader: 'システム<br>タスキー利用者ID',
                column: {
                    type: 'text',
//                    width: 25,
                },
                readOnly: true,
            },
            {
                name: 'status',
                get: (v, v_all) => { return v },
                load: (v) => { return v.status },
                colHeader: '状態',
                column: {
                    type: 'text',
                    renderer: DATA.RENDERERS.STATUS,
//                    width: 30,
                },
                readOnly: true,
            },
        ],
        SYSTEM_UPDATED_AT: [
            {
                name: 'updated_at',
                get: (v, v_all) => { return v },
                load: (v) => { return v.updated_at },
                colHeader: 'updated_at',
                column: {
                    type: 'text',
                },
                readOnly: true,
            },
        ],
        USER: [
            {
                name: 'pec',
                get: (v, v_all) => { return v },
                load: (v) => { return v },
                colHeader: '利用者入力<br>PEC管理番号',
                column: {
                    renderer: DATA.RENDERERS.PEC,
                    width: 100,
                },
                readOnly: true,
            },
            {
                name: 'marunage_user_id',
                get: (v, v_all) => { return v },
                load: (v) => { return v.marunage_user_id },
                colHeader: '利用者ID',
                column: {
                    type: 'text',
                    width: 60,
                },
                change_to_render: true,
            },
            {
                name: 'issued_at',
                get: (v, v_all) => { return v },
                load: (v) => { return v.issued_at },
                colHeader: '年月日',
                column: {
                    renderer: COMMON().RENDERERS.YYYY_MM_DD,
                    width: 80,
                },
                change_to_render: true,
            },
            {
                name: 'sequence_number',
                get: (v, v_all) => { return v },
                load: (v) => { return v.sequence_number },
                colHeader: '卸管理番号',
                column: {
//                    width: 15,
                    renderer: DATA.RENDERERS.SEQUENCE_NUMBER,
                    className: 'text-right',
                },
                change_to_render: true,
            },
            {
                name: 'product',
                get: (v, v_all) => { return v },
                load: (v) => { return v.product },
                colHeader: '商品名',
                column: {
                    width: 300,
//                    renderer: DATA.RENDERERS.ELLIPSIS,
                },
            },
            {
                name: 'note_user',
                get: (v, v_all) => { return v },
                load: (v) => { return v.note_user },
                colHeader: '連絡事項',
                column: {
                    width: 300,
                },
            },
        ],
        INSPECTOR: [
            {
                name: 'note_inspector',
                get: (v, v_all) => { return v },
                load: (v) => { return v.note_inspector },
                colHeader: 'Prova入力<br>連絡事項',
                column: {
                    width: 300,
                },
            },
            {
                name: 'note_checkup',
                get: (v, v_all) => { return v },
                load: (v) => { return v.note_checkup },
                colHeader: '検品詳細',
                column: {
                    width: 300,
                },
            },
            {
                name: 'media',
                get: (v, v_all) => { return v },
                load: (v) => { return v.media_urls },
                colHeader: '画像リンク',
                column: {
//                    width: 50,
                    renderer: DATA.RENDERERS.MEDIA,
                },
            },
            {
                name: 'labeled_at',
                get: (v, v_all) => { return v },
                load: (v) => { return '';v.labeled_at },
                colHeader: 'ラベル出力',
                column: {
                    renderer: COMMON().RENDERERS.YYYY_MM_DD,
                    width: 80,
                },
            },

            {
                name: 'space',
                get: (v, v_all) => { return v },
                load: (v) => { return '' },
                colHeader: 'D3PL入力<br>受取日',
                column: {
//                    autoWidth: true,
//                    width: 50,
                },
                readOnly: true,
            },
//            {
//                name: 'shipping_tracking_log',
//                get: (v, v_all) => { return v },
//                load: (v) => { return v.shipping_tracking_log },
//                colHeader: '追跡情報',
//                column: {
//                    type: 'text',
//                    renderer: COMMON().RENDERERS.shipping_tracking_log,
//                },
//            },
//            {
//                name: 'shipping_tracking_confirmed_at',
//                get: (v, v_all) => { return v },
//                load: (v) => { return v.shipping_tracking_confirmed_at },
//                colHeader: '追跡有効確認日時',
//                column: {
//                    type: 'date',
//                    dateFormat: 'YYYY-MM-DD HH:mm',
//                    correctFormat: true,
//                },
//            },
//            {
//                name: 'shipping_marunage_charge',
//                get: (v, v_all) => { return v },
//                load: (v) => { return v.shipping_marunage_charge },
//                colHeader: '保険料(JPY)',
//                column: {
//                    type: 'numeric',
//                    numericFormat: {
//                        pattern: '0,0',
//                    },
//                },
//                readOnly: true,
//            },
//            {
//                name: 'profile_representative',
//                get: (v, v_all) => { return v },
//                load: (v) => { return v.profile_representative },
//                colHeader: '登記<br>氏名<i class="required" />',
//                column: {
//                    type: 'text',
//                },
//            },
//            {
//                name: 'profile_company',
//                get: (v, v_all) => { return v },
//                load: (v) => { return v.profile_company },
//                colHeader: '会社名/屋号<i class="required" />',
//                column: {
//                    type: 'text',
//                },
//            },
//            {
//                name: 'profile_address',
//                get: (v, v_all) => { return v },
//                load: (v) => { return v.profile_address },
//                colHeader: '住所<i class="required" />',
//                column: {
//                    type: 'text',
//                },
//            },
//            {
//                name: 'profile_tel',
//                get: (v, v_all) => { return v },
//                load: (v) => { return v.profile_tel },
//                colHeader: '電話<i class="required" />',
//                column: {
//                    type: 'text',
//                },
//            },
//            {
//                name: 'profile_email',
//                get: (v, v_all) => { return v },
//                load: (v) => { return v.profile_email },
//                colHeader: 'メール<i class="required" />',
//                column: {
//                    type: 'text',
//                },
//            },
        ],
        // 発送人
        D3PL: [
//            {
//                name: 'from_representative',
//                get: (v, v_all) => { return v },
//                load: (v) => { return v.from_representative },
//                colHeader: '発送人<br>氏名(en)<i class="required" />',
//                column: {
//                    type: 'text',
//                },
//            },
//            {
//                name: 'from_company',
//                get: (v, v_all) => { return v },
//                load: (v) => { return v.from_company },
//                colHeader: '会社名/屋号(en)<i class="required" />',
//                column: {
//                    type: 'text',
//                },
//            },
//            {
//                name: 'from_address',
//                get: (v, v_all) => { return v },
//                load: (v) => { return v.from_address },
//                colHeader: '住所(en)<i class="required" />',
//                column: {
//                    type: 'text',
//                },
//            },
//            {
//                name: 'from_tel',
//                get: (v, v_all) => { return v },
//                load: (v) => { return v.from_tel },
//                colHeader: '電話<i class="required" />',
//                column: {
//                    type: 'text',
//                },
//            },
//            {
//                name: 'from_email',
//                get: (v, v_all) => { return v },
//                load: (v) => { return v.from_email },
//                colHeader: 'メール<i class="required" />',
//                column: {
//                    type: 'text',
//                },
//            },
        ],
    }
    DATA.FIELDS_ALL =
        DATA.FIELDS.SYSTEM
        .concat(DATA.FIELDS.SYSTEM_UPDATED_AT)
        .concat(DATA.FIELDS.USER)
        .concat(DATA.FIELDS.INSPECTOR)
        .concat(DATA.FIELDS.D3PL)
    return DATA
}

export default _DATA

